module.exports = {"id":"213242","name":"Adrien Tamèze","rating":"71","photo":"./data/images/photos/1/213242.png","club":{"name":"OGC Nice","logo":"./data/images/clubs/OGCNice.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdrienTameze0.json
// module id = 117
// module chunks = 0